<template>
  <article ref="scrollBox" class="bus_list_wrap home CompareFlightIndex city">
    <header class="pages_title" id="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1)"><i class="iconfont_new icon-Left"></i></div>
        <div class="myHeader textalignM">选择城市</div>
        <div class="myHeaderR textalignR"></div>
      </div>
    </header>

    <section class="pages_content" id="pages_content" ref="pages_content">


      <div class="inputPlace">
        <!-- 地名：<input type="text" v-on:keyup="inputPlace" :value="myCityName" placeholder="输入地名" />
        <button @click="clear">重置</button> -->
        <Input v-model="myCityName" placeholder="请输入你要搜索的城市或首字母拼音" clearable style="width: 96%;border-radius: 4px;border: #E77618 solid 2px;" />
      </div>

      <div>
        <div class="cityClass" id="star" ref="star">热门城市</div>
        <div style="display: flex;flex-wrap: wrap;padding: 5px 15px;padding-right: 25px;align-items: center;">
          <div style="width:29%;border: 1px #ddd solid;border-radius: 3px;margin-right: 3%;text-align: center;padding: 8px 0;margin-bottom: 13px;font-size: 15px;color: #333;position: static;" class="cityName" v-for="(item, key) in hotCity" :key="key" @click="select(item)">{{ item.cityName }}</div>
        </div>
      </div>

      <div class v-for="(word, key, index) in rightArr" :key="key" :id="'index' + word">
        <!-- <div class="cityClass" :id="data.initial" :ref="data.initial">{{ data.initial }}</div> -->
        <div class="cityClass" :ref="word">{{ word }}</div>
        <div class="cityName" v-for="(item, key1, index2) in showCityData" :key="key1" @click="select(item)" v-if="word == item.spell[0]">{{ item.cityName }}</div>
      </div>

      <div class="cityNavigation">
        <div class="cityNavigationName" @click="goPositioning('star')" v-bind:class="{ cityNavigationName_select: curSelectInitial == 'star' }"
          v-if="false">
          <Icon type="md-star" />
        </div>
        <!-- <div class="cityNavigationName" v-for="data in cityData"	:key="data.initial"	@click="goPositioning(data.initial)" v-bind:class="{ cityNavigationName_select: curSelectInitial == data.initial }">
					{{ data.initial }}
				</div> -->
        <div class="cityNavigationName" v-for="data in rightArr" :key="data" @click="goPositioning('index' + data)"
          v-bind:class="{ cityNavigationName_select: curSelectInitial == data }">
          {{ data }}
        </div>
      </div>
    </section>
  </article>
</template>

<script>
  // import cityData from '@/json/city.json';
  import flightApi from '../request/flightApi';
  import {
    mapState
  } from 'vuex';
  export default {
    name: 'City',
    data() {
      return {
        // cityData: cityData.city, // test
        // cityData: [], // 原始城市数据，不用程序修改，查找都从里调并组成新数组。
        //当前选中的字母：
        curSelectInitial: 'star',
        //热门城市：
        hotCity: [{
            cityName: '广州',
            pinYin: 'Guangzhou',
            spell: 'GZ',
            code: 'CAN',
            airPortList: [{
              airPortName: '广州白云国际机场',
              airPortCode: 'CAN'
            }]
          },
          {
            cityName: '北京',
            pinYin: 'Beijing',
            spell: 'BJ',
            code: 'BJS',
            airPortList: [{
              airPortName: '北京首都国际机场',
              airPortCode: 'PEK'
            }, {
              airPortName: '北京大兴国际机场',
              airPortCode: 'PKX'
            }]
          },
          {
            cityName: '深圳',
            pinYin: 'Shenzhen',
            spell: 'SZ',
            code: 'SZX',
            airPortList: [{
              airPortName: '深圳宝安国际机场',
              airPortCode: 'SZX'
            }]
          },
          {
            cityName: '上海',
            pinYin: 'Shanghai',
            spell: 'SH',
            code: 'SHA',
            airPortList: [{
              airPortName: '上海虹桥国际机场',
              airPortCode: 'SHA'
            }, {
              airPortName: '上海浦东国际机场',
              airPortCode: 'PVG'
            }]
          },
          {
            cityName: '长沙',
            pinYin: 'Changsha',
            spell: 'CS',
            code: 'CSX',
            airPortList: [{
              airPortName: '长沙黄花国际机场',
              airPortCode: 'CSX'
            }]
          },
          {
            cityName: '重庆',
            pinYin: 'Chongqing',
            spell: 'CQ',
            code: 'CKG',
            airPortList: [{
              airPortName: '重庆江北国际机场',
              airPortCode: 'CKG'
            }]
          },
          {
            cityName: '厦门',
            pinYin: 'Xiamen',
            spell: 'XM',
            code: 'XMN',
            airPortList: [{
              airPortName: '厦门高崎国际机场',
              airPortCode: 'XMN'
            }]
          },
          {
            cityName: '三亚',
            pinYin: 'Sanya',
            spell: 'SY',
            code: 'SYX',
            airPortList: [{
              airPortName: '三亚凤凰国际机场',
              airPortCode: 'SYX'
            }]
          },
          {
            cityName: '海口',
            pinYin: 'Haikou',
            spell: 'HK',
            code: 'HAK',
            airPortList: [{
              airPortName: '海口美兰国际机场',
              airPortCode: 'HAK'
            }]
          },
          {
            cityName: '昆明',
            pinYin: 'Kunming',
            spell: 'KM',
            code: 'KMG',
            airPortList: [{
              airPortName: '昆明长水国际机场',
              airPortCode: 'KMG'
            }]
          },
          {
            cityName: '杭州',
            pinYin: 'Hangzhou',
            spell: 'HZ',
            code: 'HGH',
            airPortList: [{
              airPortName: '杭州萧山国际机场',
              airPortCode: 'HGH'
            }]
          },
          {
            cityName: '成都',
            pinYin: 'Chengdu',
            spell: 'CD',
            code: 'CTU',
            airPortList: [{
              airPortName: '成都双流国际机场',
              airPortCode: 'CTU'
            }]
          },
          {
            cityName: "西安",
            pinYin: "Xi'an",
            spell: "XA",
            code: "XIY",
            airPortList: [{
              airPortName: "西安咸阳国际机场",
              airPortCode: "XIY"
            }]
          },
          {
            cityName: "青岛",
            pinYin: "Qingdao",
            spell: "QD",
            code: "TAO",
            airPortList: [{
              airPortName: "青岛流亭国际机场",
              airPortCode: "TAO"
            }]
          },
          {
            cityName: "哈尔滨",
            pinYin: "Harbin",
            spell: "HEB",
            code: "HRB",
            airPortList: [{
              airPortName: "哈尔滨太平国际机场",
              airPortCode: "HRB"
            }]
          },
        ],
        //每个字母的顶部距离数组
        topList: [],

        showCityData: [],
        selectType: 'dep',
        rightArr: [], // 右字母数组
        jumpNum: '', // 跳转字母
        myCityName: '' // 搜索字母或文字
      };
    },
    components: {},
    activated() {
      if (this.$route.params.mode && this.$route.params.mode != '') {
        this.selectType = this.$route.params.mode;
      }
      this.getCityData();
    },
    mounted() {
      //初始化默认：
      this.curSelectInitial = 'star';
      document.getElementById('star').scrollIntoView({
        block: 'start' // 上边框与视窗顶部平齐。默认值
      });

      let headerheight = document.getElementById('pages_title').offsetHeight; //顶部高度
      //每个字母的顶部距离数组：
      this.topList = [];
      for (let i = 0; i < this.cityData.length; i++) {
        this.topList.push(document.getElementById(this.cityData[i].initial).offsetTop - headerheight);
      }
      // console.log(topList);
      this.checkScroll();
    },
    destroyed() {
      // window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
    },
    methods: {
      clear() {
        this.myCityName = '';
        this.searchWord(this.myCityName);
      },
      searchWord(val) {
        let data = this.cityData;
        let newData = [];
        if (val == '') {
          this.resetRight(this.cityData);
          return;
        }
        for (let i = 0; i < data.length; i++) {
          if (escape(val).indexOf('%u') != -1) {
            // 是汉字
            if (data[i].cityName.indexOf(val) != -1) {
              newData.push(data[i]);
            }
          } else {
            // 字符
            if (data[i].spell[0] == val.toUpperCase()) {
              newData.push(data[i]);
            }
          }
        }
        this.resetRight(newData)
      },
      // 重置右侧跳转字母与显示数据
      resetRight(data) {
        for (let j = 0; j < data.length - 1; j++) {
          //两两比较，如果前一个比后一个大，则交换位置。
          for (let i = 0; i < data.length - 1 - j; i++) {
            if (data[i].spell.substr(0, 1) > data[i + 1].spell.substr(0, 1)) {
              let temp = data[i];
              data[i] = data[i + 1];
              data[i + 1] = temp;
            }
          }
        }

        let rightArr = [];
        for (let i = 0; i < data.length; i++) {
          let word = data[i].spell.substr(0, 1);
          if (rightArr.indexOf(word) == -1) {
            rightArr.push(data[i].spell.substr(0, 1));
          }
        }
        this.rightArr = rightArr;
        this.showCityData = data;
      },
      // 获取城市数据
      getCityData() {
        let that = this;
        // this.cityData = [];
        this.showCityData = [];
        if (this.cityData.length == 0) {
          flightApi.getCityData().then(sucRes => {
            // this.cityData = sucRes.data;
            this.$store.commit('flight/setFlightQueryCondition', {
              cityData: sucRes.data
            });
            this.resetRight(sucRes.data);
          });
        } else {
          this.resetRight(this.cityData);
        }
      },
      //监听滚轮事件：滚到哪个位置，右边的导航自动更新：
      checkScroll() {
        var that = this;
        document.getElementById('pages_content').addEventListener('scroll', function() {
          let val = that.$refs.pages_content.scrollTop;

          let index = that.find(that.topList, val);
          // console.log(index);

          if (index == 0) {
            that.curSelectInitial = 'star';
          } else {
            that.curSelectInitial = that.cityData[index - 1].initial;
          }
        });
      },

      //传入数组，和值：寻找这个值在这个数组的下标
      find(array, val) {
        if (val < Math.min.apply(null, array)) {
          return 0;
        }
        if (val > Math.max.apply(null, array)) {
          return array.length - 1;
        }
        var idx = 0,
          i = 0,
          j = array.length;
        for (; i < j; i++) {
          if (array[i] > val) {
            idx = i;
            break;
          }
        }
        return idx;
      },

      //选择城市：
      select(cityItem) {
        console.log('选择城市：', cityItem);
        if (this.selectType == 'dep') {
          // 出发地点
          this.$store.commit('flight/setFlightQueryCondition', {
            depCity: cityItem.cityName,
            depCityPortCode: cityItem.code
          });
        } else if (this.selectType == 'arr') {
          // 到达地点
          this.$store.commit('flight/setFlightQueryCondition', {
            arrCity: cityItem.cityName,
            arrCityPortCode: cityItem.code
          });
        }
        this.$router.go(-1);
      },
      //定位：
      goPositioning(id) {
        this.curSelectInitial = id;
        document.getElementById(id).scrollIntoView({
          // behavior: "smooth",  // 平滑过渡
          block: 'start' // 上边框与视窗顶部平齐。默认值
        });
      },
      inputPlace(e) {
        this.myCityName = e.target.value;
      },
      // search(){
      //   console.log(e)
      //   let data = this.showCityData;
      //   let newData = [];
      //   if (e.target.value == '') {
      //     this.resetRight(this.showCityData);
      //     return;
      //   }
      //   for (let i = 0; i < data.length; i++) {
      //     if (escape(e.target.value).indexOf('%u') != -1) { // 是汉字
      //       if (data[i].cityName.indexOf(e.target.value) != -1) {
      //         newData.push(data[i]);
      //       }
      //     } else { // 字符
      //       if (data[i].spell[0] == e.target.value.toUpperCase()) {
      //         newData.push(data[i]);
      //       }
      //     }
      //   }
      //   this.resetRight(newData);
      // },
    },
    watch: {
      myCityName(newval, oldval) {
        this.searchWord(newval);
      }
    },
    computed: mapState({
      cityData: state => state.flight.cityData
    })
  };
</script>

<style scoped lang="less">
  @import '../style/home.less';

  .pages_title {
    background-color: transparent;
    padding: 0;
    color: #fff;
    border-bottom: none;
  }
  .inputPlace{
    margin:20px 0 10px 10px;
    display: flex;
    // justify-content: space-between;
  }
  .inputPlace input{
    border-radius:5px;
    margin-right:10px;
    border:1px solid rgb(90, 90, 90);
  }
</style>



// WEBPACK FOOTER //
// src/components/City.vue